import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { TextField, Button } from '@mui/material';
import DeleteIcon from '../assets/images/deletePopup.svg';

interface DeleteConfirmationDialogProps {
  open: boolean;
  handleClose: () => void;
  handleDelete: () => void;
  page: string;
  btntext?: string;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  open,
  handleClose,
  handleDelete,
  page,
  btntext = 'Delete',
}) => {
  const [confirmationText, setConfirmationText] = useState('');
  const isDeleteButtonDisabled = confirmationText !== btntext.toUpperCase();

  return (
    <Dialog
      className="popup"
      open={open}
      onClose={handleClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
    >
      <DialogTitle id="delete-dialog-title" className="text-center">
        <img src={DeleteIcon} alt={`Delete ${page} icon`} width="32" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          className="text-center"
          id="delete-dialog-description"
        >
          Please, type &quot;{btntext.toUpperCase()}&quot; to remove it <br />
          from the List.
          {/* {page === 'role' ? (
            <>
              Are you sure you want to <br /> delete this role? <br />
              <p>
                Along with the role, assigned permissions <br /> will also be
                deleted.
              </p>
            </>
          ) : page === 'user' ? (
            <>
              Are you sure you want to <br /> {btntext} this user? <br />
            </>
          ) : page === 'profile' ? (
            <>
              Are you sure, you want to delete <br />
              this profile picture?
            </>
          ) : null} */}
          <TextField
            fullWidth
            margin="normal"
            variant="outlined"
            value={confirmationText}
            onChange={(e) => setConfirmationText(e.target.value)}
            className="delete-input"
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions className="dialog-actions">
        <Button
          onClick={handleClose}
          color="primary"
          variant="contained"
          className="delete-cancel-btn"
        >
          Cancel
        </Button>
        <Button
          onClick={handleDelete}
          color="primary"
          variant="contained"
          className={btntext == 'activate' ? 'active-btn' : 'delete-btn'}
          disabled={isDeleteButtonDisabled}
        >
          {btntext}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const MemoizedComponent = React.memo(DeleteConfirmationDialog);
export default MemoizedComponent;
